
export default class CustomDropdown {
    constructor() {
        this.init();
    }

    init() {
        document.querySelectorAll('.form__custom-dropdown').forEach(dropdown => {
            const options = dropdown.querySelectorAll('.dropdown-options li');
            const selected = dropdown.querySelector('.dropdown-selected');
            const hiddenInputId = dropdown.dataset.dropdownId;
            const hiddenInput = document.getElementById(hiddenInputId);

            options.forEach(option => {
                option.addEventListener('click', () => {
                    const selectedValue = option.dataset.value;

                    selected.textContent = option.textContent;

                    if (hiddenInput) {
                        hiddenInput.value = selectedValue;
                    }

                    dropdown.classList.remove('open');
                    dropdown.setAttribute('aria-expanded', 'false');
                });
            });

            selected.addEventListener('click', () => {
                const isOpen = dropdown.classList.toggle('open');
                dropdown.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            });

            document.addEventListener('click', (e) => {
                if (!dropdown.contains(e.target)) {
                    dropdown.classList.remove('open');
                    dropdown.setAttribute('aria-expanded', 'false');
                }
            });
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new CustomDropdown();
});



